import { Flex, Text } from '@chakra-ui/react';
import Image from 'next/image';
import { FC } from 'react';

import DigitalLibraryImage from '@/assets/images/landing/digital-library.png';

export const DigitalLibrary: FC = () => {
  return (
    <Flex flexDirection={{ base: 'column', lg: 'row' }} alignItems="center" gap={8} mt={12}>
      <Image alt="Digital Library" src={DigitalLibraryImage} />
      <Text fontSize="xl">
        We have now opened our platform to individuals, so you can publicize and showcase your work to a global research
        audience.
        <br />
        <br />
        For only $19.95 per presentation, you can submit your video to our Digital Video Library, where it will be
        enriched with searchable transcripts, metadata, and a DOI for easy discovery and citation.
      </Text>
    </Flex>
  );
};
